
import Vue from 'vue'
import UiCard from '@/components/UiCard.vue'

export default Vue.extend({
  name: "Error404",
  data(){
    return {}
  },
  computed: {
    backlink(){
      return `/${this.$store.getters.organization?.id || ''}`
    }
  },
  methods: {},
  components: {
    UiCard,
  },
})
